import styles from './TableNoRowsPlaceholder.module.scss';

import { Table } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';

interface TableNoRowsPlaceholderProps {
  table: Table<unknown>;
}

export function TableNoRowsPlaceholderV8(props: TableNoRowsPlaceholderProps) {
  const { table } = props;

  const { t } = useTranslation();

  const state = table.getState();

  const hasColumnFilters = state.columnFilters.length > 0;
  const hasGlobalFilter = !!state.globalFilter;

  const renderMessage = () => {
    const messageKey = hasColumnFilters
      ? hasGlobalFilter
        ? 'LISTS_PAGES.NO_RESULTS.FILTERS_AND_SEARCH'
        : 'LISTS_PAGES.NO_RESULTS.FILTERS'
      : hasGlobalFilter
      ? 'LISTS_PAGES.NO_RESULTS.SEARCH'
      : 'LISTS_PAGES.NO_RESULTS.DEFAULT';

    return <span className={styles.message}>{t(messageKey)}</span>;
  };

  const maybeRenderButton = () => {
    if (!hasColumnFilters) return null;

    return (
      <button
        className={styles.button}
        type="button"
        onClick={() => {
          table.resetColumnFilters();
        }}
      >
        {t('LISTS_PAGES.NO_RESULTS.BUTTON')}
      </button>
    );
  };

  return (
    <div className={styles.root}>
      {renderMessage()} {maybeRenderButton()}
    </div>
  );
}
